import { Component, Input } from '@angular/core';

import { GridData, CellComponent, CellContext } from '@grid/models';

@Component({
  selector: 'app-copy-checkbox-edit',
  templateUrl: './custom-checkbox-edit.component.html',
  styleUrls: ['./custom-checkbox-edit.component.scss'],
})
export class CustomCheckboxEditComponent implements CellComponent<GridData> {
  @Input({ required: true }) context!: CellContext<GridData>;
}
